export default __webpack_public_path__ + "static/media/bankIcon.27bb4c43.png";